<template>
	<div class="omapi-card__flex omapi-dash__resources">
		<common-card class="omapi-dash__resources" title="Helpful Resources" type="minimize">
			<ul class="omapi-detailed-list">
				<li>
					<a :href="$urls.docs('getting-started-optinmonster-wordpress-checklist/', 'DashboardResources')" class="omapi-link-title omapi-book" target="_blank" rel="noopener noreferrer">Read the OptinMonster User Guide to Get Started</a>
				</li>
				<li>
					<a :href="$urls.docs('', 'DashboardResources')" class="omapi-link-title omapi-document" target="_blank" rel="noopener noreferrer">View Our Documentation</a>
				</li>
				<li>
					<a :href="$urls.utmLink($urls.marketing('contact-us/'), {utm_medium : 'DashboardResources'})" class="omapi-link-title omapi-help" target="_blank" rel="noopener noreferrer">Contact Our Expert Support Team for Help</a>
				</li>
				<li>
					<a :href="$urls.utmLink($urls.app('university/'), {utm_medium : 'DashboardResources'})" class="omapi-link-title omapi-university" target="_blank" rel="noopener noreferrer">Access OptinMonster University Courses to Increase Conversions</a>
				</li>
				<li v-if="showProUpsells">
					<core-upgrade-button
						class="omapi-link-title omapi-rocket rocket-blue"
						:linkStyle="true"
						utmMedium="DashboardResources"
					>
						Upgrade to Unlock More Powerful Features
					</core-upgrade-button>

				</li>
			</ul>
		</common-card>
	</div>
</template>
<script>
import { mapGetters } from 'vuex'

export default  {
	computed : {
		...mapGetters([ 'showProUpsells' ]),
	},
}
</script>
